import schema from "./schema/widen.video";
import { definePlugin } from "sanity";

export default definePlugin({
  name: "widen-video",
  schema: {
    types: [schema]
  }
});
